import React, { useEffect, useState } from 'react';
import { useInViewOnce } from '../../hooks/useInViewOnce';
interface CountUpProps {
  to: number;
  duration?: number;
  className?: string;
}
export function CountUp({
  to,
  duration = 1.4,
  className
}: CountUpProps) {
  const {
    ref,
    inView
  } = useInViewOnce<HTMLSpanElement>(0.5);
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (!inView) return;
    if (typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setValue(to);
      return;
    }
    let frame = 0;
    const start = performance.now();
    const tick = (now: number) => {
      const progress = Math.min((now - start) / (duration * 1000), 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(Math.round(eased * to));
      if (progress < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [inView, to, duration]);
  return <span ref={ref} className={className} data-id="element-141" data-mp="hl81pmd65msy">
      {value}
    </span>;
}